export default (element) => {
  const menuListButtons = element.querySelectorAll(
    '[data-footer-menu-list-title]',
  );

  const newsletterForm = element.querySelector('#newsLetterForm');
  const emailInput = element.querySelector('#NewsletterForm--footer');
  const telInput = element.querySelector('[data-id=NewsletterFormTel]');
  const agreementInput = element.querySelector('#newsletter-agreement');
  const agreementTel = element.querySelector('#newsletter-agreement-tel');
  const promoCodeInput = element.querySelector('#newsletter-promo-code');
  const promoCodeSuccess = element.querySelector('#newsletter-promo-success');
  const formEmailError = element.querySelector('#form-error-message');
  const formConsentError = element.querySelector('#form-consent-message');
  const formTelError = element.querySelector('#form-error-message-tel');
  const formConsentTelError = element.querySelector(
    '#form-consent-message-tel',
  );
  const successMessage = element.querySelector('[data-success]');
  const completedItems = element.querySelectorAll('[data-completed]');
  const newsletterIdAttr = element.querySelector('[data-newsletter-id]');
  const newsletterId = newsletterIdAttr ? newsletterIdAttr.getAttribute('data-newsletter-id') : null;
  const companyIdAttr = element.querySelector('[data-company-id]');
  const companyId = companyIdAttr ? companyIdAttr.getAttribute('data-company-id') : null;

  const menuLinkToggle = () => {
    menuListButtons.forEach((listItem) =>
      listItem.addEventListener('click', () => {
        listItem.lastElementChild
          .querySelector('line')
          .classList.toggle('hidden');
        listItem.nextElementSibling.classList.toggle('hidden');
      }),
    );
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(promoCodeInput.value).then(() => {
      promoCodeSuccess.textContent = 'Copied!';
    });
  };

  const validateEmail = (email) =>
    // eslint-disable-next-line no-useless-escape, max-len
    /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
      email,
    );

  // eslint-disable-next-line max-len
    const validatePhone = (inputValue) => /^\+\d{1,3}\(\s*\d{1,4}\s*\)\s*\d{1,}\s*-\s*\d{1,}$/g.test(inputValue);
    
    const applyPhoneInputMask =  (e) => {
     
      const x = e.target.value
        .replace(/\+1|\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = `+1${x[1] ? `( ${x[1]} ) ` : ''}${x[2]}${
        x[3] ? ` - ${x[3]}` : ''
      }`;
  };

  const validateForm = () => {
    const emailIsValid = emailInput ? validateEmail(emailInput.value) : false;
    const telIsValid = telInput ? validatePhone(telInput.value) : false;

    let formIsValid = false;
    if (telInput && emailInput) {
      formIsValid =
        emailIsValid &&
        agreementInput.checked &&
      agreementInput.checked && 
        agreementInput.checked &&
      agreementInput.checked && 
        agreementInput.checked &&
        telIsValid &&
      telIsValid && 
        telIsValid &&
      telIsValid && 
        telIsValid &&
        agreementTel?.checked;
    } else if (emailInput && !telInput) {
      formIsValid = emailIsValid && agreementInput.checked;
    } else if (telInput && !emailInput) {
      formIsValid = telIsValid && agreementTel?.checked;
    }

    if (!formIsValid) {
      newsletterForm.classList.add('invalid');
      if (!emailIsValid && emailInput) {
        formEmailError?.classList.remove('hidden');
      } else {
        formEmailError?.classList.add('hidden');
      }
      if (!telIsValid && telInput) {
        formTelError?.classList.remove('hidden');
      } else {
        formTelError?.classList.add('hidden');
      }
      if (!agreementInput?.checked && emailInput) {
        formConsentError?.classList.remove('hidden');
      } else {
        formConsentError?.classList.add('hidden');
      }
      if (!agreementTel?.checked && telInput) {
        formConsentTelError?.classList.remove('hidden');
      } else {
        formConsentTelError?.classList.add('hidden');
      }
    } else {
      newsletterForm?.classList.remove('invalid');
      formEmailError?.classList.add('hidden');
      formTelError?.classList.add('hidden');
      formConsentError?.classList.add('hidden');
      formConsentTelError?.classList.add('hidden');
    }
    return formIsValid;
  };

  const initNewsletterForm = () => {
    if (newsletterForm) {
      const formHeight = newsletterForm.offsetHeight;
      const styleTag = document.createElement('style');
      const formParent = newsletterForm.parentElement;
      styleTag.innerHTML = `
        #newsLetterForm {
          min-height: auto;
        }

        @media (min-width: 1024px) {
          #newsLetterForm {
            min-height: ${formHeight}px;
          }
        }
      `;
      formParent.insertBefore(styleTag, newsletterForm);
      newsletterForm.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (validateForm() && newsletterId) {
          const attributes = {
            list_id: newsletterId,
            custom_source: 'Newsletter form',
          };

          if (emailInput) attributes.email = emailInput.value;
          if (telInput) attributes.phone_number = telInput.value;

          const options = {
            method: 'POST',
            headers: {
              revision: '2023-01-24',
              'content-type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes,
              },
            }),
          };

          fetch(
            // eslint-disable-next-line max-len
            `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
            options,
          ).then((response) => {
            if (response.ok) {
              successMessage.classList.remove('hidden');
              completedItems.forEach((item) => item.classList.add('hidden'));
            }
          });
        }
      });
    }

    if (emailInput) {
      emailInput.addEventListener('keyup', () => {
        if (newsletterForm.classList.contains('invalid')) {
          validateForm();
        }
      });
    }
    if (telInput) {
      telInput.addEventListener('keyup', (e) => {
        applyPhoneInputMask(e);
        if (newsletterForm.classList.contains('invalid')) {
          validateForm();
        }
      });
    }
  };

  const reopenWidgetInit = () => {
    window.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        const el = document.getElementById('reopen_widget');
        if (el) {
          el.style.display = 'none';
          const menu = document.querySelector('[copy-menu]');
          const copyrightTextEl = menu.querySelector('[copyright-text]');
          const liEl = document.createElement('li');
          liEl.textContent = el.textContent;
          liEl.classList.add(
            'text-body-3',
            'text-black',
            'hover:underline',
            'lg:max-w-max',
            'cursor-pointer',
          );
          liEl.addEventListener('click', () => {
            el.click();
          });
          if (copyrightTextEl) {
            menu.insertBefore(liEl, copyrightTextEl);
          } else {
            menu.appendChild(liEl);
          }
        }
      }, 1000);
    });
  };

  const init = () => {
    menuLinkToggle();
    initNewsletterForm();
    promoCodeInput?.addEventListener('click', copyToClipboard);
    reopenWidgetInit();
  };
  init();
};
